<template>
  <div
    class="rounded-xl bg-base-300 p-5 sm:p-6 text-left shadow-md"
  >
    <h2 class="text-lg font-semibold text-base-content">Get updates</h2>
    <p class="text-sm opacity-70 mt-1 mb-4">
      Drop your email if you want occasional news about Stock Jockey development.
    </p>
    <form
      action="https://buttondown.com/api/emails/embed-subscribe/turek"
      method="post"
      class="embeddable-buttondown-form flex flex-col gap-3 sm:flex-row sm:items-end sm:gap-3"
    >
        <input
          type="email"
          name="email"
          :id="emailInputId"
          placeholder="you@example.com"
          class="input input-bordered w-full bg-base-100/90 border-base-content/20"
          required
        autocomplete="email"
      />
      <button type="submit" class="btn btn-primary w-full sm:w-auto shrink-0">
        Subscribe
      </button>
    </form>
    <p class="mt-3 text-xs opacity-50">
      <a
        href="https://buttondown.com/refer/turek"
        target="_blank"
        rel="noopener noreferrer"
        class="link link-hover"
      >
        Powered by Buttondown.
      </a>
    </p>
  </div>
</template>

<script setup>
import { useId } from 'vue'

const emailInputId = useId()
</script>
